import firebase from 'firebase'

const config = {
  apiKey: "AIzaSyDz7xFBP2IAkg4T-Fo4_kuswkA2attdOFM",
  authDomain: "sales-portal-19c24.firebaseapp.com",
  databaseURL: "https://sales-portal-19c24.firebaseio.com",
  projectId: "sales-portal-19c24",
  storageBucket: "sales-portal-19c24.appspot.com",
  messagingSenderId: "957036221628"
}

firebase.initializeApp(config)

export const ref = firebase.database().ref()
export const firebaseAuth = firebase.auth


// WEBPACK FOOTER //
// ./src/constants.js